<div class="p-grid" class="container">
    <div class="p-col-12">
        <div class="p-grid">
            <div class="p-col-2">
                <img src="{{lien}}" alt="photos du client" style="cursor: pointer; max-width: 100%; max-height: 100%;" (click)="img.toggle($event)">
                <p-overlayPanel #img>
                    <ng-template pTemplate>
                        <img src="{{lien}}" alt="photos du client">
                    </ng-template>
                </p-overlayPanel>
            </div>

            <div [class]="(cq === true || readonly === true)?'p-col-4':'p-col-7'">
                <div class="p-grid">
                    <div class="p-col-12">
                        <textarea pInputTextarea style="width:100%"  autoResize="autoResize" [rows]="5" [disabled] = "disabled" [(ngModel)]="contenu" (ngModelChange)="descriptionChanged(contenu)"></textarea>
                    </div>
                    <ng-template [ngIf]="(cq === false && readonly === false)">
                        <div class="p-col-4">
                            <button pButton type="button" [label]="btnModifierLabel" style="width: 100%; background-color: steelblue; border-color: steelblue;" (click)="setEditable()"></button>
                        </div>
                    </ng-template>
                </div>
               
            </div>

            <div class="p-col-1" style="text-align: center;">
                <div style="border-left:1px solid darkgrey;height:100%; width:0; margin:auto; border-width: medium;"></div>
            </div>
        
            <div class="p-col-2">
                <div class="p-grid">
                    <div class="p-col-12" style="text-align: left;">
                        <h4>Contenu dupliqué</h4>
                        <div class="p-grid" style="width:100%;margin: auto">
                            <div class="p-col-6"><p-radioButton [disabled]="(cq || readonly)" [name]="duplicateName" [value]="true" label="Oui" [(ngModel)]="duplicate" inputId="id_duplicate"></p-radioButton></div>
                            <div class="p-col-6"><p-radioButton [disabled]="(cq || readonly)" [name]="duplicateName" [value]="false" label="Non" [(ngModel)]="duplicate" inputId="not_duplicate"></p-radioButton></div>
                        </div>
                    </div>
                    <ng-template [ngIf]="duplicate === false">
                        <div class="p-col-12" style="text-align: left;">
                            <h4>Statut</h4>
                            <div class="p-grid" style="width:100%;margin: auto">
                                <div class="p-col-6"><p-radioButton [disabled]="(cq || readonly)" [name]="validName" [value]="true" label="OK" [(ngModel)]="valid" inputId="is_valid"></p-radioButton></div>
                                <div class="p-col-6"><p-radioButton [disabled]="(cq || readonly)" [name]="validName" [value]="false" label="KO" [(ngModel)]="valid" inputId="non_valid"></p-radioButton></div>
                            </div>
                        </div>
                        <ng-template [ngIf]="valid === false">
                            <div class="p-col-12" >
                                <app-erreurs [cq]="(cq || readonly)"></app-erreurs>
                            </div>
                        </ng-template>
        
                    </ng-template>
                </div>
            </div>

            <ng-template [ngIf]="cq === true || readonly === true">
                <div class="p-col-1">
                    <div style="border-left:1px solid darkgrey;height:100%; width:0; margin:auto; border-width: medium;"></div>
                </div>
        
                <div class="p-col-2">
                    <div class="p-grid">
                        <div class="p-col-12" style="text-align: left;">
                            <h4>CQ</h4>
                            <div class="p-grid" style="width:100%;margin: auto">
                                <div class="p-col-6"><p-radioButton [disabled]="readonly" [name]="cqName" [value]="true" label="OK" [(ngModel)]="validationCQ" inputId="is_valid"></p-radioButton></div>
                                <div class="p-col-6"><p-radioButton [disabled]="readonly" [name]="cqName" [value]="false" label="KO" [(ngModel)]="validationCQ" inputId="non_valid"></p-radioButton></div>
                            </div>
                        </div>
                        <ng-template [ngIf]="validationCQ === false">
                            <div class="p-col-12" >
                                <app-erreurs [cq]="readonly"></app-erreurs>
                            </div>
                        </ng-template>
        
                        
                    </div>
                </div>
           </ng-template>
           
        </div>
    </div>

    
</div>
